<div class="ui-dialog">
    <div class="ui-dialog-content" mat-dialog-content>
        <div class="payment" #reciptElement id="reciptElement">
            <div class="payment-header">
                <div class="payment-header-logo"><img src="assets/images/logo-color.png"></div>
                <div class="payment-header-recipt">
                    <span class="payment-title">Comprobante de pago</span><span class="payment-description">{{payment.recipt}}</span>
                </div>
            </div>

            <div class="payment-balance">
                <div class="payment-balance-amount">
                    <span class="payment-title">Total pagado</span>
                    <h1>$ {{payment.amount}}</h1>
                </div>
                
                <div class="payment-balance-details">
                    Detalle de la operación<br>
                    Medio de pago: {{payment.methodPayment}}
                    <ul>
                        <li><span>Total pagado:</span><span>$ {{payment.amount}}</span></li>
                        <li><span>Saldo pendiente de pago:</span><span>$ {{payment.amountPending}}</span></li>
                    </ul>
                </div>
            </div>

            <div class="payment-date">
                <!--<div><span class="payment-title">Fecha de emisión</span><span class="payment-description">{{payment.date | date: 'dd/MM/yyyy'}}</span></div>-->
                <div><span class="payment-title">Fecha de pago</span><span class="payment-description">{{payment.datePayment | date: 'dd/MM/yyyy'}}</span></div>
            </div>
        </div>
    </div>
  
    <div class="ui-dialog-actions" mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cerrar</button>
      <button mat-button color="primary" cdkFocusInitial [mat-dialog-close]="true" (click)="onDownload()">Descargar</button>
    </div>
  </div>